import { Columns, Column, Text } from 'braid-design-system';
import type { FC, ReactElement } from 'react';

export interface FreemiumModalDotpoints {
  content: ReactElement;
  icon: ReactElement;
}

export const DotPointItem: FC<FreemiumModalDotpoints> = ({ content, icon }) => (
  <Columns space="xxsmall" alignY="top">
    <Column width="content">
      <Text size="small">{icon}</Text>
    </Column>
    <Column>{content}</Column>
  </Columns>
);
